import { get } from 'lodash-es';
import { useI18n } from 'vue-i18n';

import {
  API_ERROR_KEY_MAP,
  DEFAULT_API_ERROR_KEY,
  translateApiError,
} from './apiErrorKeyMap';

const { isArray } = Array;

export const useErrors = () => {
  const { t } = useI18n();

  const e = (key, fallback) => {
    const translationKey = API_ERROR_KEY_MAP[key];

    if (translationKey) {
      return translateApiError(t, translationKey);
    }

    return fallback ?? key;
  };

  const getResponseErrors = (errorResult) => {
    const errors = get(errorResult, 'response.data.error_messages');
    if (errors) {
      return Object.keys(errors).map(key => e(key, errors[key]));
    }

    if (get(errorResult, 'response.status') === 401) return '';

    return e(errorResult.message, e(DEFAULT_API_ERROR_KEY));
  };

  const showResponseErrors = (errorResponse, callback) => {
    const errors = getResponseErrors(errorResponse);
    if (!errors || !callback) return;

    if (isArray(errors)) {
      [...new Set(errors.filter(Boolean))].forEach(error => callback(error));
    } else {
      callback(errors || '');
    }
  };

  return { e, getResponseErrors, showResponseErrors };
};
